import React, { useState, useEffect, useCallback } from 'react'
import axios from 'axios';
import Popup from 'popup/Popup';

import { PopupBox, PopupHandle } from './Checker.css';

const Checker = () => {
  const [status, setStatus] = useState(false);

  const checkServerStatus = useCallback(() => {
    axios.get('/api/check/server')
      .then(response => {
        if (status === true) {
          window.location.reload();
        }
      })
      .catch(function (error) {
        setStatus(true);
      });
  }, [status])
  
  useEffect(() => {
    checkServerStatus();
  
    const timer = window.setInterval(() => {
      checkServerStatus();
    }, Number(10000));
  
    return () => {
      window.clearInterval(timer);
    };
  }, [status])

  return (
    <Popup
      open={status}
      onClose={() => {setStatus(false);}}
      modal
      closeOnDocumentClick
    >
      <PopupBox>
        <PopupHandle className="popup-handle">
          <div>
            서버와 연결이 끊어졌습니다. 관리자에게 문의해주세요.
          </div>
        </PopupHandle>
      </PopupBox>
    </Popup>
  )
}

export default Checker;